import { createLoadingScreen } from "../../DomUtilities/ElementsCreator";
import openErrorModal from "../../Error/ErrorModal";
import { deleteVariant, fetchDeleteVariantModal } from "../../HTTPRequests/VariantRequests";
import Mediator from "../../Utilities/Mediator";

export default class DeleteVariantModal {
	serviceId: string;
	itemId: string;
	loadingScreen: HTMLElement;
	variantId: string;
	editModalDiv: HTMLDivElement;

	constructor(itemId: string, serviceId: string, variantId: string, editModal: HTMLDivElement) {
		this.loadingScreen = createLoadingScreen();
		this.itemId = itemId;
		this.serviceId = serviceId;
		this.variantId = variantId;
		this.editModalDiv = editModal;
	}

	public addDeleteModalClickListener() {
		const deleteButton: HTMLButtonElement = document.querySelector('#update-variant-modal button');
		deleteButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.fetchDeleteModal();
		}
	}

	private fetchDeleteModal() {
		fetchDeleteVariantModal(this.serviceId, this.variantId)
			.then((response: string) => {
				this.openDeleteModal(response);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	public openDeleteModal(modalHTMLString: string) {
		const modalDiv: HTMLDivElement = document.createElement("div");
		document.body.appendChild(modalDiv);
		modalDiv.innerHTML = modalHTMLString;

		const cancelButton: HTMLButtonElement = document.querySelector('#delete-variant-modal button');
		cancelButton.onclick = () => {
			modalDiv.remove();
		};

		const image: HTMLImageElement = document.querySelector('#delete-variant-modal img[alt="close icon"]');
		image.onclick = () => {
			modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#delete-variant-modal button:last-child');
		saveButton.onclick = () => {
			document.body.append(this.loadingScreen);
			this.deleteVariant(modalDiv);
		}
	}

	private deleteVariant(modalDiv: HTMLDivElement) {
		deleteVariant(this.itemId, this.serviceId, this.variantId)
			.then(() => {
				modalDiv.remove();
				this.editModalDiv.remove();
				Mediator.emit("variantCrudOperationFinished");
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}

